var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef } from 'react';
import { Route, useHistory, useParams } from 'react-router-dom';
import { services } from '../../../shared';
import { APPLICATION, FEES, CASEDOCUMENTS, CASEDECLARATIONS, ILLUSTRATION } from '../../../config/routes';
import { Workflow } from '../../sections/workflow/workflow';
import { Documents, Fees, QuestionSets, Declarations, Illustrations } from '../../sections';
import { defaultErrorResponse, hasError } from '../../../shared/types/service-handling';
import { manageCaseRouteNavigation, reloadCaseLocation, } from '../../sections/case-navigation/case-route-navigation/case-route-navigation';
import { questionDataType } from '../../../shared/types/constants';
import { useAppSelector } from '../../app/hooks';
import { useLoader } from '../../../shared/utils';
var QuestionSetInitialState = {
    data: null,
    loading: false,
    error: false,
};
export var ApplicationPage = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var location = _a.location;
    var _q = useParams(), caseId = _q.caseId, sectionId = _q.sectionId, loanPurposeId = _q.loanPurposeId;
    var fetchedLocation = useRef(null);
    var _r = useState([]), pages = _r[0], setPages = _r[1];
    var _s = useState(0), activeLoanPurposeId = _s[0], setActiveLoanPurposeId = _s[1];
    var _t = useState(), workflowStep = _t[0], setWorkflowStep = _t[1];
    var _u = useState(), workflowSteps = _u[0], setWorkflowSteps = _u[1];
    var _v = useState(), questionSet = _v[0], setQuestionSet = _v[1];
    var _w = useState(), autoDeclineAnswers = _w[0], setAutoDeclineAnswers = _w[1];
    var _x = useState(QuestionSetInitialState), shQuestionSet = _x[0], setShQuestionSet = _x[1];
    var history = useHistory();
    var activeCaseId = (_e = (_d = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : Number(caseId)) !== null && _e !== void 0 ? _e : 0;
    var isAdmin = useAppSelector(function (state) { return state.adminData.adminData.isAdmin; });
    var sessionCaseId = useAppSelector(function (state) { return state.adminData.adminData.caseId; });
    var sessionFormId = useAppSelector(function (state) { return state.adminData.adminData.formId; });
    var sessionLoanPurposeId = useAppSelector(function (state) { return state.adminData.adminData.loanPurposeId; });
    var fetchQuestionSet = function (caseId, sectionId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var questionSetData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShQuestionSet(__assign(__assign({}, shQuestionSet), { loading: true }));
                    if (!(sectionId > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.getQuestionSets(caseId, sectionId, formId)];
                case 1:
                    questionSetData = _a.sent();
                    formatDate(questionSetData === null || questionSetData === void 0 ? void 0 : questionSetData.data);
                    setShQuestionSet(questionSetData);
                    if (questionSetData.data) {
                        setQuestionSet(questionSetData.data);
                        setQuestionSet(function (prevState) {
                            var _a;
                            var updatedApplicantWiseRowPositionList = (_a = prevState === null || prevState === void 0 ? void 0 : prevState.applicantWiseRowPositionList) === null || _a === void 0 ? void 0 : _a.map(function (applicant) {
                                var _a;
                                if (((_a = applicant === null || applicant === void 0 ? void 0 : applicant.rowPositionList) === null || _a === void 0 ? void 0 : _a.length) === 0 || (applicant === null || applicant === void 0 ? void 0 : applicant.rowPositionList) === null) {
                                    return __assign(__assign({}, applicant), { rowPositionList: [1] });
                                }
                                return applicant;
                            });
                            return __assign(__assign({}, prevState), { applicantWiseRowPositionList: updatedApplicantWiseRowPositionList });
                        });
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var fetchAutoDeclineAnswers = function (sectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var autoDeclines;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(sectionId > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.getAutoDeclineAnswers(sectionId)];
                case 1:
                    autoDeclines = (_a.sent()).data;
                    setAutoDeclineAnswers(autoDeclines);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var manageLocationAndNavigation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (!!((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.case)) return [3 /*break*/, 2];
                    return [4 /*yield*/, reloadCaseLocation(location, {
                            caseId: activeCaseId,
                        })];
                case 1:
                    location = _g.sent();
                    _g.label = 2;
                case 2:
                    setActiveLoanPurposeId((_f = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.loanPurposeId) !== null && _c !== void 0 ? _c : (_e = (_d = location === null || location === void 0 ? void 0 : location.state) === null || _d === void 0 ? void 0 : _d.case) === null || _e === void 0 ? void 0 : _e.loanPurposeId) !== null && _f !== void 0 ? _f : Number(loanPurposeId));
                    if (!workflowStep) return [3 /*break*/, 4];
                    return [4 /*yield*/, manageNavigation(activeCaseId, location.state.loanPurposeId)];
                case 3:
                    _g.sent();
                    _g.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var caseSectionMenuSetIsLoading = useLoader({
        identifier: 'caseSectionMenu',
    }).caseSectionMenuSetIsLoading;
    var questionSetsSetIsLoading = useLoader({
        identifier: 'questionSets',
    }).questionSetsSetIsLoading;
    var manageNavigation = function (currentCase, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var currentWorkflowStep, _a, requiresRedirect, url, pageWithStatus, newLocation, updatedPageWithStatus;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    currentWorkflowStep = workflowStep;
                    if (sessionStorage.getItem('isAdmin') === 'true') {
                        currentWorkflowStep.formId = Number(sessionFormId);
                    }
                    return [4 /*yield*/, manageCaseRouteNavigation({
                            params: {
                                caseId: currentCase,
                                loanPurposeId: loanPurposeId,
                                sectionId: Number(sectionId),
                            },
                            location: location,
                            setPages: function (pages) {
                                caseSectionMenuSetIsLoading(false);
                                setPages(pages);
                            },
                            step: currentWorkflowStep,
                        })];
                case 1:
                    _a = _e.sent(), requiresRedirect = _a.requiresRedirect, url = _a.url, pageWithStatus = _a.pageWithStatus, newLocation = _a.newLocation;
                    fetchedLocation.current = __assign(__assign({}, newLocation), { state: __assign(__assign({}, newLocation.state), { pages: pages, workflowName: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formType }) });
                    if (!requiresRedirect) return [3 /*break*/, 2];
                    history.push(url);
                    caseSectionMenuSetIsLoading(false);
                    return [3 /*break*/, 7];
                case 2:
                    if (!(pageWithStatus.id === undefined)) return [3 /*break*/, 4];
                    return [4 /*yield*/, services.getPagesWithStatus(currentCase, currentWorkflowStep.formId)];
                case 3:
                    updatedPageWithStatus = (_e.sent()).data;
                    _e.label = 4;
                case 4:
                    caseSectionMenuSetIsLoading(false);
                    return [4 /*yield*/, fetchQuestionSet(currentCase, pageWithStatus.id === undefined
                            ? sessionStorage.getItem('isAdmin') === 'true'
                                ? (pageWithStatus.id =
                                    ((_b = updatedPageWithStatus[0]) === null || _b === void 0 ? void 0 : _b.sections) == null
                                        ? (_c = updatedPageWithStatus[1]) === null || _c === void 0 ? void 0 : _c.sections[0].id
                                        : (_d = updatedPageWithStatus[0]) === null || _d === void 0 ? void 0 : _d.sections[0].id)
                                : pageWithStatus.id
                            : pageWithStatus.id, currentWorkflowStep.formId)];
                case 5:
                    _e.sent();
                    questionSetsSetIsLoading(false);
                    return [4 /*yield*/, fetchAutoDeclineAnswers(pageWithStatus.id)];
                case 6:
                    _e.sent();
                    _e.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getApplicationApplicantIdFromElementName = function (elName) {
        return Number(elName.split('-')[0]);
    };
    var getQuestionIdFromElementName = function (elName) {
        return Number(elName.split('-')[1]);
    };
    var getRowPositionFromElementName = function (elName) {
        return Number(elName.split('-')[2]);
    };
    useEffect(function () {
        var _a, _b;
        if ((_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.pages) {
            caseSectionMenuSetIsLoading(false);
            setPages((_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.pages);
        }
    }, []);
    var setAutoDeclineRefer = function (elementId, selectedSection, elementValue, elementListsId) {
        var qId = getQuestionIdFromElementName(elementId);
        var applicationApplicantId = getApplicationApplicantIdFromElementName(elementId);
        var rowPosition = getRowPositionFromElementName(elementId);
        var matchedAutoDecline = autoDeclineAnswers === null || autoDeclineAnswers === void 0 ? void 0 : autoDeclineAnswers.filter(function (q) { return q.formSectionQuestionId === qId; });
        var matched = matchedAutoDecline.length > 0 && elementValue
            ? matchedAutoDecline.find(function (x) { return x.value === elementValue; })
            : elementListsId
                ? matchedAutoDecline.find(function (x) { return x.listsId === elementListsId; })
                : false;
        if (matched) {
            setAnswer(qId, applicationApplicantId, elementValue ? elementValue : elementListsId ? elementListsId.toString() : '', selectedSection, matched.refer === true, matched.refer === false, rowPosition);
        }
        else {
            setAnswer(qId, applicationApplicantId, elementValue ? elementValue : elementListsId ? elementListsId.toString() : '', selectedSection, false, false, rowPosition);
        }
    };
    var setAnswer = function (questionId, applicationApplicantId, elementValue, selectedSection, autoRefer, autoDecline, rowPosition) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var answer = (_a = selectedSection.answers) === null || _a === void 0 ? void 0 : _a.find(function (a) {
            return a.formSectionQuestionId === questionId &&
                a.rowPosition === rowPosition &&
                a.applicationApplicantId === applicationApplicantId;
        });
        if (!answer) {
            selectedSection.answers = __spreadArray(__spreadArray([], selectedSection.answers, true), [
                {
                    applicationApplicantId: applicationApplicantId,
                    formSectionQuestionId: questionId,
                    value: elementValue,
                    rowPosition: rowPosition !== null && rowPosition !== void 0 ? rowPosition : 1,
                    autoRefer: autoRefer,
                    autoDecline: autoDecline,
                    applicationId: Number((_e = (_d = (_c = (_b = fetchedLocation === null || fetchedLocation === void 0 ? void 0 : fetchedLocation.current) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.case) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : (_g = (_f = location === null || location === void 0 ? void 0 : location.state) === null || _f === void 0 ? void 0 : _f.case) === null || _g === void 0 ? void 0 : _g.id),
                },
            ], false);
        }
        else {
            var indexOfQuestion = Number((_j = (_h = selectedSection.answers) === null || _h === void 0 ? void 0 : _h.findIndex(function (p) { return p == answer; })) !== null && _j !== void 0 ? _j : -1);
            selectedSection.answers = __spreadArray(__spreadArray(__spreadArray([], selectedSection.answers.slice(0, indexOfQuestion), true), [
                __assign(__assign({}, answer), { value: elementValue, autoDecline: autoDecline, autoRefer: autoRefer, rowPosition: rowPosition })
            ], false), selectedSection.answers.slice(indexOfQuestion + 1), true);
        }
    };
    var addAnother = function (e) {
        var _a;
        var selectedSection = Object.assign({}, questionSet);
        var dataValues = e.currentTarget.getAttribute('data-value').split('|');
        var applicationApplicantId = Number(dataValues[0]);
        var formSectionQuestionId = Number(dataValues[1]);
        var answersToQuestion = (_a = selectedSection.answers) === null || _a === void 0 ? void 0 : _a.filter(function (ans) {
            return ans.formSectionQuestionId === formSectionQuestionId && ans.applicationApplicantId === applicationApplicantId;
        });
        if ((answersToQuestion === null || answersToQuestion === void 0 ? void 0 : answersToQuestion.length) === 0) {
            setAnswer(formSectionQuestionId, applicationApplicantId, '', selectedSection, false, false, 1);
        }
        else {
            var lastAnswer = answersToQuestion[answersToQuestion.length - 1];
            var newAnswerPosition = lastAnswer.rowPosition + 1;
            setAnswer(formSectionQuestionId, applicationApplicantId, '', selectedSection, false, false, newAnswerPosition);
        }
        setQuestionSet(selectedSection);
    };
    var addAnotherSection = function (e) {
        var _a, _b;
        var selectedSection = Object.assign({}, questionSet);
        var dataValues = e.currentTarget.getAttribute('data-value').split('|');
        var applicationApplicantId = Number(dataValues[0]);
        var countofans = Number(dataValues[1]);
        var applicant = (_a = selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.applicantWiseRowPositionList) === null || _a === void 0 ? void 0 : _a.find(function (applicant) { return applicant.applicationApplicantId === applicationApplicantId; });
        if (applicant && applicant.rowPositionList) {
            applicant.rowPositionList.push(applicant.rowPositionList.length + 1);
        }
        var answersToQuestion = (_b = selectedSection.answers) === null || _b === void 0 ? void 0 : _b.filter(function (ans) { return ans.applicationApplicantId === applicationApplicantId && ans.rowPosition === countofans; });
        if ((selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.allowMultiple) === true) {
            answersToQuestion === null || answersToQuestion === void 0 ? void 0 : answersToQuestion.map(function (answer) {
                return setAnswer(answer === null || answer === void 0 ? void 0 : answer.formSectionQuestionId, applicationApplicantId, '', selectedSection, false, false, (answer === null || answer === void 0 ? void 0 : answer.rowPosition) + 1);
            });
        }
        setQuestionSet(selectedSection);
    };
    var removeLast = function (e) {
        var _a;
        var selectedSection = Object.assign({}, questionSet);
        var dataValues = e.currentTarget.getAttribute('data-value').split('|');
        var applicationApplicantId = Number(dataValues[0]);
        var formSectionQuestionId = Number(dataValues[1]);
        var answersToQuestion = (_a = selectedSection.answers) === null || _a === void 0 ? void 0 : _a.filter(function (ans) {
            return ans.applicationApplicantId === applicationApplicantId && ans.formSectionQuestionId === formSectionQuestionId;
        });
        if ((answersToQuestion === null || answersToQuestion === void 0 ? void 0 : answersToQuestion.length) > 1) {
            var ansToRemove = answersToQuestion[answersToQuestion.length - 1];
            selectedSection.answers.splice(selectedSection.answers.indexOf(ansToRemove), 1);
        }
        setQuestionSet(selectedSection);
    };
    var removeLastSection = function (e) {
        var _a, _b;
        var selectedSection = Object.assign({}, questionSet);
        var dataValues = e.currentTarget.getAttribute('data-value').split('|');
        var applicationApplicantId = Number(dataValues[0]);
        var countofans = Number(dataValues[1]);
        var answersToQuestion = (_a = selectedSection.answers) === null || _a === void 0 ? void 0 : _a.filter(function (ans) { return ans.applicationApplicantId === applicationApplicantId && ans.rowPosition === countofans; });
        if (countofans > 1) {
            answersToQuestion === null || answersToQuestion === void 0 ? void 0 : answersToQuestion.forEach(function (answer) {
                var _a;
                var index = selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.answers.indexOf(answer);
                if (index !== -1) {
                    (_a = selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.answers) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
                }
            });
            var applicant = (_b = selectedSection === null || selectedSection === void 0 ? void 0 : selectedSection.applicantWiseRowPositionList) === null || _b === void 0 ? void 0 : _b.find(function (applicant) { return applicant.applicationApplicantId === applicationApplicantId; });
            if (applicant && applicant.rowPositionList) {
                applicant.rowPositionList.splice(countofans - 1, 1);
            }
        }
        setQuestionSet(selectedSection);
    };
    var getListOptionValue = function (input) {
        var _a;
        return ((_a = input === null || input === void 0 ? void 0 : input.selectedOptions) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? input === null || input === void 0 ? void 0 : input.selectedOptions[0].value
            : input.id.split('--')[1];
    };
    var inputBoolChangeHandler = function (e) {
        var selectedSection = Object.assign({}, questionSet);
        var elementName = e.currentTarget.name;
        var elementValue = e.currentTarget.value;
        setAutoDeclineRefer(elementName, selectedSection, elementValue.toLowerCase() === 'true' ? 'true' : 'false');
        var currentQuestionId = Number(e.currentTarget.name.split('-')[1]);
        var currentRowPosition = Number(e.currentTarget.name.split('-')[2]);
        showHideQuestions(currentQuestionId, selectedSection, elementValue, null, getApplicationApplicantIdFromElementName(elementName), currentRowPosition);
    };
    var showHideQuestions = function (questionId, selectedSection, boolValue, listValue, applicationApplicantId, rowPosition) {
        var _a;
        var section = selectedSection !== null && selectedSection !== void 0 ? selectedSection : Object.assign({}, questionSet);
        var currentQuestion = section.questions.find(function (q) { return q.id == questionId; });
        if (((_a = currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.childQuestionCount) !== null && _a !== void 0 ? _a : 0) > 0) {
            section.questions = section.questions.reduce(function (p, c) {
                var _a, _b, _c;
                var revisedQuestion = __assign({}, c);
                if (c.parentId == questionId) {
                    revisedQuestion.visibleToApplicantRowOrderWise = revisedQuestion.visibleToApplicantRowOrderWise || [];
                    var currApplicantIndexInVisiblity = revisedQuestion.visibleToApplicantRowOrderWise.findIndex(function (x) { return x.applicationApplicantId === applicationApplicantId && x.rowNumber === rowPosition; });
                    var currentRowPosition = revisedQuestion === null || revisedQuestion === void 0 ? void 0 : revisedQuestion.visibleToApplicantRowOrderWise.some(function (x) { return x.rowNumber === rowPosition; });
                    if ((boolValue && c.parentAnswerValue == boolValue) ||
                        (listValue && c.parentAnswerListsId == listValue) ||
                        (listValue && ((_a = c.parentAnswerList) === null || _a === void 0 ? void 0 : _a.indexOf(listValue)) >= 0)) {
                        if (currApplicantIndexInVisiblity < 0) {
                            revisedQuestion.visibleToApplicantRowOrderWise = __spreadArray(__spreadArray([], revisedQuestion.visibleToApplicantRowOrderWise, true), [
                                {
                                    applicationApplicantId: applicationApplicantId,
                                    rowNumber: rowPosition,
                                    isChildQuestionVisible: true,
                                },
                            ], false);
                        }
                        if (currentRowPosition === true) {
                            var updatedArray = revisedQuestion.visibleToApplicantRowOrderWise.map(function (item) {
                                if (item.rowNumber === rowPosition) {
                                    return __assign(__assign({}, item), { isChildQuestionVisible: true });
                                }
                                else {
                                    return item;
                                }
                            });
                            revisedQuestion.visibleToApplicantRowOrderWise = updatedArray;
                        }
                    }
                    else {
                        revisedQuestion.visibleToApplicantRowOrderWise = __spreadArray(__spreadArray([], revisedQuestion.visibleToApplicantRowOrderWise.slice(0, currApplicantIndexInVisiblity), true), revisedQuestion.visibleToApplicantRowOrderWise.slice(currApplicantIndexInVisiblity + 1), true);
                    }
                    revisedQuestion.isChildQuestionVisible = ((_c = (_b = revisedQuestion.visibleToApplicantRowOrderWise) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0;
                }
                p = __spreadArray(__spreadArray([], p, true), [revisedQuestion], false);
                return p;
            }, []);
        }
        setQuestionSet(section);
    };
    var inputListChangeHandler = function (e) {
        var selectedSection = Object.assign({}, questionSet);
        var elementName = e.currentTarget.name;
        var elementValue = Number(getListOptionValue(e.currentTarget));
        var currentQuestionId = Number(e.currentTarget.name.split('-')[1]);
        var currentRowPosition = Number(e.currentTarget.name.split('-')[2]);
        setAutoDeclineRefer(elementName, selectedSection, null, Number(elementValue));
        showHideQuestions(currentQuestionId, selectedSection, null, Number(elementValue), getApplicationApplicantIdFromElementName(elementName), currentRowPosition);
    };
    var rootPath = "".concat(APPLICATION.paths[0], "/").concat(activeCaseId, "/").concat(activeLoanPurposeId, "/").concat(workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId, "/");
    var formatDate = function (data) {
        var _a, _b;
        var sectionWiseDateQuestion = (_a = data.questions) === null || _a === void 0 ? void 0 : _a.filter(function (que) { return que.dataType == questionDataType.dateOfBirth || que.dataType == questionDataType.date; });
        (_b = data.answers) === null || _b === void 0 ? void 0 : _b.forEach(function (ans) {
            sectionWiseDateQuestion === null || sectionWiseDateQuestion === void 0 ? void 0 : sectionWiseDateQuestion.forEach(function (ques) {
                if ((ans === null || ans === void 0 ? void 0 : ans.formSectionQuestionId) == ques.id) {
                    var dateParts = ans.value.split('/');
                    if (ans.value.includes('/') && dateParts.length == 3) {
                        var _a = dateParts.map(function (part) { return parseInt(part); }), day = _a[0], month = _a[1], year = _a[2];
                        var date = new Date(Date.UTC(year, month - 1, day));
                        ans.value = date.toISOString().split('T')[0];
                    }
                }
            });
        });
    };
    var restrictToRedirect = function (currentPath, sessionCaseId, sessionLoanPurposeId, sessionFormId) {
        var pathParts = currentPath.split('/');
        var currentCaseId = parseInt(pathParts[3]);
        var currentLoanPurposeId = parseInt(pathParts[4]);
        var currentFormId = parseInt(pathParts[5]);
        if (pathParts[pathParts.length - 1].toLowerCase() === 'illustrations' ||
            pathParts[pathParts.length - 1].toLowerCase() === 'submit' ||
            pathParts[pathParts.length - 1].toLowerCase() === 'complete') {
            return false;
        }
        return (currentCaseId === sessionCaseId &&
            currentLoanPurposeId === sessionLoanPurposeId &&
            currentFormId === sessionFormId);
    };
    useEffect(function () {
        if (isAdmin &&
            !restrictToRedirect(window.location.pathname, Number(sessionCaseId), Number(sessionLoanPurposeId), Number(sessionFormId))) {
            window.open("".concat(window.location.origin, "/cases/application/").concat(sessionCaseId, "/").concat(sessionLoanPurposeId, "/").concat(sessionFormId), '_self');
        }
        else {
            manageLocationAndNavigation();
        }
    }, [caseId, workflowStep, sectionId]);
    if (hasError([shQuestionSet])) {
        return defaultErrorResponse();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Workflow, { caseId: activeCaseId, loanPurposeId: activeLoanPurposeId, setActiveWorkflowStep: setWorkflowStep, setWorkflowSteps: setWorkflowSteps, location: (_f = fetchedLocation === null || fetchedLocation === void 0 ? void 0 : fetchedLocation.current) !== null && _f !== void 0 ? _f : location }),
        React.createElement(Route, { key: "sub-route-".concat(FEES.id), exact: true, path: FEES.paths },
            React.createElement(Fees, { pages: pages, steps: workflowSteps, rootPath: rootPath, location: (_g = fetchedLocation === null || fetchedLocation === void 0 ? void 0 : fetchedLocation.current) !== null && _g !== void 0 ? _g : location, caseId: activeCaseId, formId: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId, workflowName: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formType })),
        React.createElement(Route, { key: "sub-route-".concat(CASEDOCUMENTS.id), exact: true, path: CASEDOCUMENTS.paths },
            React.createElement(Documents, { pages: pages, steps: workflowSteps, rootPath: rootPath, location: (_h = fetchedLocation === null || fetchedLocation === void 0 ? void 0 : fetchedLocation.current) !== null && _h !== void 0 ? _h : location, caseId: activeCaseId, loanPurposeId: (_k = (_j = location === null || location === void 0 ? void 0 : location.state) === null || _j === void 0 ? void 0 : _j.case) === null || _k === void 0 ? void 0 : _k.loanPurposeId, formId: (workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId) == 0
                    ? Number(location.pathname.split('/')[location.pathname.split('/').length - 2])
                    : workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId, workflowName: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formType })),
        React.createElement(Route, { key: "sub-route-".concat(CASEDECLARATIONS.id), exact: true, path: CASEDECLARATIONS.paths },
            React.createElement(Declarations, { pages: pages, steps: workflowSteps, rootPath: rootPath, location: (_l = fetchedLocation === null || fetchedLocation === void 0 ? void 0 : fetchedLocation.current) !== null && _l !== void 0 ? _l : location, caseId: activeCaseId, formId: (workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId) == 0
                    ? Number(location.pathname.split('/')[location.pathname.split('/').length - 2])
                    : workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId, workflowName: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formType })),
        React.createElement(Route, { key: "sub-route-".concat(APPLICATION.id), path: APPLICATION.paths, exact: true },
            React.createElement(QuestionSets, { pages: pages, steps: workflowSteps, rootPath: rootPath, location: (_m = fetchedLocation === null || fetchedLocation === void 0 ? void 0 : fetchedLocation.current) !== null && _m !== void 0 ? _m : location, questionSet: questionSet, caseId: activeCaseId, formId: (_o = workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId) !== null && _o !== void 0 ? _o : 0, inputBoolChangeHandler: inputBoolChangeHandler, inputListChangeHandler: inputListChangeHandler, addAnother: addAnother, workflowName: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formType, removeLast: removeLast, currentSectionId: sectionId !== null && sectionId !== void 0 ? sectionId : '', autoDeclineAnswers: autoDeclineAnswers, showHideQuestion: showHideQuestions, addAnotherSection: addAnotherSection, removeLastSection: removeLastSection })),
        React.createElement(Route, { key: "sub-route-".concat(ILLUSTRATION.id), exact: true, path: ILLUSTRATION.path },
            React.createElement(Illustrations, { location: (_p = fetchedLocation === null || fetchedLocation === void 0 ? void 0 : fetchedLocation.current) !== null && _p !== void 0 ? _p : location, pages: pages, steps: workflowSteps, rootPath: rootPath, caseId: activeCaseId, loanPurposeId: activeLoanPurposeId, workflowName: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formType, formId: workflowStep === null || workflowStep === void 0 ? void 0 : workflowStep.formId }))));
};
